import {css, useTheme} from "@emotion/react";
import {backgroundColor, mb, p} from "@pg-design/helpers-css";
import {Picture} from "@pg-design/picture";
import {Text} from "@pg-design/text";

import {IEntryCategory} from "../../types/Category";
import {ContentItem, EntryVisibility} from "../../types/Entry";
import {shouldShowPaywall} from "../../utils/should_show_paywall";
import {InfoTextBlock} from "../InfoTextBlock";
import {ArticlePaywallPlaceholder} from "./paywall/ArticlePaywallPlaceholder";
import {ArticleContentItem} from "./ArticleContentItem";

interface IHeroProps {
    className?: string;
    title: string;
    images: {
        img_840x523: string;
        img_744x463: string;
        img_430x268: string;
    } | null;
    lead: string | null;
    publication_date: string;
    region_name: string | null;
    category: Array<IEntryCategory> | null;
    id: number;
    content: Array<ContentItem> | null;
    source: string | null;
    author: string | null;
    visibility?: EntryVisibility;
}

export const Hero = ({
    title,
    images,
    lead,
    publication_date,
    category,
    region_name,
    content,
    source,
    author,
    visibility = "public",
    className
}: IHeroProps) => {
    const theme = useTheme();

    return (
        <div className={className} css={[backgroundColor("#fff")]}>
            {images && (
                <figure css={imgHolder}>
                    <Picture
                        css={picture}
                        sources={[
                            {minWidthPX: 0, src: images.img_430x268, width: 430, height: 268},
                            {
                                minWidthPX: theme.breakpoints.numeric.xs,
                                src: images.img_744x463,
                                width: 744,
                                height: 463
                            },
                            {
                                minWidthPX: theme.breakpoints.numeric.md,
                                src: images.img_840x523,
                                width: 840,
                                height: 523
                            }
                        ]}
                        alt={title}
                    />
                </figure>
            )}

            <div css={textWrapper}>
                <InfoTextBlock
                    css={mb(2)}
                    publication_date={publication_date}
                    region_name={region_name}
                    category={category}
                />

                <Text variant="headline_1" css={mb(4)}>
                    {title}
                </Text>

                {lead && (
                    <Text variant="body_copy_0" strong css={mb(3)}>
                        {lead}
                    </Text>
                )}

                {shouldShowPaywall(content, visibility) ? (
                    <ArticlePaywallPlaceholder visibility={visibility} />
                ) : (
                    content?.map((contentItem, index) => <ArticleContentItem key={index} contentItem={contentItem} />)
                )}

                {author && <Text variant="body_copy_1">Autor: {author}</Text>}

                {source && <Text variant="body_copy_1">Źródło: {source}</Text>}
            </div>
        </div>
    );
};

const picture = css`
    > img {
        height: 100%;
        width: 100%;
        object-fit: cover;
    }
`;

const imgHolder = css`
    margin: 0;
`;

const textWrapper = css`
    ${p(2, 3, 2, 3)};
`;
